import TYPE from '../actions/TYPE';

const initialState = {
  list: {},
  loading: false
};

const paymentContent = (state = initialState, action = {}) => {
  switch (action.type) {
    case TYPE.GET_LIST_PAYMENT_CONTENT_SUCCESS:
      return {
        ...state,
        list: action?.data || [],
        loading: false
      };

    default:
      return state;
  }
};

export default paymentContent;
